import { CommonState } from "../state";

import { GEOFENCING_ERROR } from "./geofencing.const";
import { CountryAreaStatus, GeoFencingErrorType } from "./geofencing.model";

export namespace GeofencingSelector {
	export const isValid = (state: CommonState): boolean | undefined => state.geofencing.valid;
	export const isBusy = (state: CommonState): boolean => state.geofencing.isBusy;
	export const getError = (state: CommonState): GeoFencingErrorType | undefined => state.geofencing.error;
	export const showNotification = (state: CommonState): boolean => state.geofencing.showNotification;
	export const countryAreaStatus = (state: CommonState): CountryAreaStatus => state.geofencing.countryAreaStatus;
	export const isWageringBlockDialogEnabled = (state: CommonState): boolean | undefined =>
		state.geofencing.isWageringBlockDialogEnabled;
	export const isInvalidArgentinePosition = (state: CommonState) =>
		state.geofencing.error === GEOFENCING_ERROR.InvalidArgentinePosition;
	export const locationId = (state: CommonState): string | undefined => state.geofencing.locationId;
}
